var map = {
	"./airplay.svg": 83110,
	"./chartmetric.svg": 93408,
	"./instagram.svg": 84520,
	"./pandora.svg": 91277,
	"./spotify.svg": 59418,
	"./tiktok.svg": 50698,
	"./youtube.svg": 10007
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25142;